// extracted by mini-css-extract-plugin
export default {"root":"styles_root__fM0aa","h2":"styles_h2__qml-G","h3":"styles_h3__LSCTG","h4":"styles_h4__qlGd8"};